module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/channels-dcd9faad62303c60f47c33e6eb805ee0.svg";